// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"1ec084ba","821":"146245ff"}[chunkId] + ".chunk.js";
};